import { combineReducers } from "redux";
import auth from "./auth/";
import { appReducer } from "./app";

const rootReducer = combineReducers({
  auth: auth,
  app: appReducer,
});

export default rootReducer;
